import api, { analyticsDevUrl } from "../api";

const PerformanceModule = () => {
  const userData = JSON.parse(localStorage.getItem("user_profile"));

  return {
    GetCoreReports: function (data) {
      return api.post(`/wallet/Report`, data);
    },

    GetPerformanceGraph: function (data) {
      const { date, product } = data;
      return api.get(
        `/transactions/report/superdealer/performance/overview?customer_id=${userData?.walletId}&service_codes=${product}&date=${date}`,
        data
      );
    },

    ListTransaction: function (data) {
      const { page, per_page, keyword, startDate, endDate } = data;
      // page=1&per_page=10&customer_id=501&keyword=2783
      return api.get(
        `/transactions/report/listings-of-agent-and-downline-v2?customer_id=${userData?.walletId}&page=${page}&per_page=${per_page}&keyword=${keyword}&StartDate=${startDate}&EndDate=${endDate}`,
        data
      );
    },

    CusstomerListing: function (data) {
      const { page, per_page, keyword } = data;
      // page=1&per_page=10&customer_id=501&keyword=2783
      return api.get(
        `/report/agent/agent-downline-listings-v2?customer_id=${userData?.walletId}&page=${page}&per_page=${per_page}&keyword=${keyword}`,
        data
      );
    },

    AgentPerformanceList: function (data) {
      const {
        aggregatorWalletId,
        start,
        end,
        serviceType,
        page,
        pageSize,
        search,
      } = data;
      return analyticsDevUrl.get(
        `Transaction/agent-performance?aggregatorWalletId=${aggregatorWalletId}&start=${start}&end=${end}&serviceType=${serviceType}&page=${page}&pageSize=${pageSize}&search=${search}`
      );
    },

    PerformanceList: function (data) {
      const {
        aggregatorWalletId,
        start,
        end,
        serviceType,
        page,
        pageSize,
        search,
        url,
      } = data;
      return analyticsDevUrl.get(
        `Transaction/${url}?aggregatorWalletId=${aggregatorWalletId}&start=${start}&end=${end}&serviceType=${serviceType}&page=${page}&pageSize=${pageSize}&search=${search}`
      );
    },

    PerformanceOverview: function (data) {
      const { aggregatorWalletId, start, end, serviceType } = data;
      return analyticsDevUrl.get(
        `Transaction/GetTransactionsGroupedByTypeAndActorForAggregator?aggregatorWalletId=${aggregatorWalletId}&start=${start}&end=${end}&serviceType=${serviceType}`
      );
    },

    AgentProductPerformanceList: function (data) {
      const { date, product, customer_id } = data;
      return api.get(
        `/transactions/report/superdealer/performance/agent-products?customer_id=${customer_id}&service_codes=${product}&date=${date}`,
        data
      );
    },

    AgentPerformanceListFromReseller: function (data) {
      const { date, product, page, per_page, customer_id } = data;
      return api.get(
        `/transactions/report/superdealer/performance/top-agents?customer_id=${customer_id}&service_codes=${product}&date=${date}&page=${page}&per_page=${per_page}`,
        data
      );
    },

    ResellerPerformanceList: function (data) {
      const { date, product, page, per_page } = data;
      return api.get(
        `/transactions/report/superdealer/performance/top-resselers?customer_id=${userData?.walletId}&service_codes=${product}&date=${date}&page=${page}&per_page=${per_page}`,
        data
      );
    },
  };
};

export const PerformanceService = {
  performanceModule: PerformanceModule,
};
